import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getNewsletter } from '../../../api/services/systemService';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const SectionContainer = styled.section`
  margin: 0 auto;
  text-align: center;
  padding: 0 1.5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0px;
`;

const NewsletterGrid = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
`;

const NewsletterCard = styled.div`
  display: flex;
  flex: 1;
  min-width: 200px;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  text-decoration: none;
  color: ${(props) => props.theme.colors.primaryText};
  box-sizing: border-box;
  overflow: hidden;
`;

const NewsletterImage = styled.img`
  background-color: rgb(140, 204, 248);
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  cursor: pointer;
`;

const NewsletterFooter = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const NewsletterTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  text-align: center;
  color: #333;
`;

const ReadMoreLink = styled(Link)`
  font-size: 1rem;
  text-underline-offset: 3px;
  text-decoration: none;
  font-weight: bold;
  color: #2b83bf;

  &:hover {
    text-decoration: underline;
  }
`;

const Newsletter = ({ show = true }) => {
  const userInfo = useSelector((state) => state.userInfo);
  // const navigate = useNavigate();
  const [newsletterList, setNewsletterList] = useState([]);

  useEffect(() => {
    getDbNewsletter();
  }, []);

  const getDbNewsletter = async () => {
    try {
      const result = await getNewsletter(userInfo.brandCode);
      const data = result.newsletter;
      setNewsletterList(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
    }
  };

  if (!show) return null;

  // const banners = [
  //   newsletterList.find((item) => item.gubun === '0'),
  //   newsletterList.find((item) => item.gubun === '1'),
  //   newsletterList.find((item) => item.gubun === '2'),
  // ];

  // const handleClick = (url) => {
  //   if (!url) return;

  //   const token = localStorage.getItem('token');

  //   if (url.startsWith('http://') || url.startsWith('https://')) {
  //     window.open(url, '_blank', 'noopener,noreferrer');
  //   } else {
  //     navigate(url);
  //   }
  // };

  return (
    <SectionContainer>
      <NewsletterGrid>
        {newsletterList.map((newsletter) => (
          <NewsletterCard key={newsletter.gubun}>
            <NewsletterImage
              src={`${process.env.REACT_APP_FILE_UPLOAD_URL}${newsletter.filepath1}`}
              alt={newsletter.title}
              onClick={() => {
                if (newsletter.showOrder == 1) {
                  window.open(newsletter.url, '_blank');
                } else {
                  window.location.href = newsletter.url;
                }
              }}
            />
            <NewsletterFooter>
              <NewsletterTitle>{newsletter.title}</NewsletterTitle>
              <ReadMoreLink
                to={newsletter.url}
                target={newsletter.showOrder == 1 ? '_blank' : '_self'}
              >
                {newsletter.descr}
              </ReadMoreLink>
            </NewsletterFooter>
          </NewsletterCard>
        ))}
      </NewsletterGrid>
    </SectionContainer>
  );
};

export default Newsletter;
